import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {PagamentoDovuto, PagamentoFiltri, RicercaPagamento} from "../models/pagamento";
import {IstanzaPagamento} from "../models/integrazione";

@Injectable({
  providedIn: 'root'
})
export class PagamentoService {
  url: string;

  constructor(private httpClient: HttpClient) {
    this.url = "services/portaletributi/api/";
  }

  istanzaPagPaginazione(filtri: PagamentoFiltri): Observable<HttpResponse<Array<IstanzaPagamento>>> {
    let url = this.url + 'istanzaPagamento/search-frontoffice?';
    // Aggiungi i parametri all'URL solo se i valori non sono nulli
    if (filtri.page !== '') {
      url += `page=${filtri.page}&`;
    }
    if (filtri.dataInizio !== null) {
      url += `dataIn=${String(filtri.dataInizio)}&`;
    }
    if (filtri.dataFine !== null) {
      url += `dataFin=${String(filtri.dataFine)}&`;
    }
    if (filtri.numEl !== '') {
      url += `size=${filtri.numEl}&`;
    }
    // Rimuovi l'eventuale carattere "&" finale se l'URL ha parametri
    if (url.endsWith('&')) {
      url = url.slice(0, -1);
    }
    return this.httpClient.get<Array<IstanzaPagamento>>(url,  {observe: 'response'});
  }


  pagamentiDovuti(filtri: RicercaPagamento): Observable<Array<PagamentoDovuto>> {
    return this.httpClient.post<Array<PagamentoDovuto>>(this.url + 'pagamentiDovuti', filtri)
  }

  pagamento(idEsterno: string): Observable<any> {
    return this.httpClient.get(this.url + 'pagamento/' + idEsterno)
  }
}
